import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import axios from 'axios';
import DataConfig from './_config.json'
var onLoading = require('./_source/onload.js');

require('./_css/getjson.css');

// var loadder = false;
var defaultCMP = localStorage.getItem("company");
// var defaultUsername = localStorage.getItem("Username");
// var HiEasyToken = localStorage.getItem("TokenHieasy");
// var HiEasyUsername = localStorage.getItem("UsernameHieasy");
console.log("defaultCMP", defaultCMP);
// อ่านค่าใหม่ทุกครั้ง เผื่อ login / เปลี่ยนบริษัท หลังจากไฟล์นี้ถูกโหลดไปแล้ว
const getToken = () => localStorage.getItem('Token');
const getHostAPI = () => DataConfig[localStorage.getItem("company") + "hostname"];
const getAPIKey = () => DataConfig["API_KEY"][localStorage.getItem("company")];


export const INSCorServicePostTest = (url, Parameter, id) => {
    onLoading.onLoading("Y");
    var urlPostTest = url +/*  "&api_key=" + API_KEY +  */"&jwt=" + getToken();
    let res = postDatatodb(urlPostTest, Parameter)
    console.log(res);
    let resreturn
    if (res !== 'error') {
        onLoading.onLoading("N");
        resreturn = res
    }
    return resreturn
}

export const INSCorServicePost = (url, Parameter, id) => {
    console.log("INSCorServicePost");
    onLoading.onLoading("Y");
    // var data ="...";
    var urlServicePost = getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken();
    console.log(urlServicePost);
    let res = postDatatodb(urlServicePost, Parameter)
    console.log(res);
    if (res) {
        onLoading.onLoading("N");
    }
    return res
}
export const GetCorService = async (url) => {
    onLoading.onLoading("Y");
    // console.log(url);
    var urlCorService = getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken();
    console.log(urlCorService);
    let res = await getDataindb(urlCorService)
    /* console.log(res.data[0].CODE ,"==",res.data[0].MYNAMETH); */
    if (res !== "error") {
        await onLoading.onLoading("N");
    }
    return res
}

export const GetCorServicei = (url, id) => {
    var Old_HTML = ""
    if (document.getElementById(id)) {
        Old_HTML = document.getElementById(id).innerHTML;
        document.getElementById(id).innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
    }
    var urlCorServicei = getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken();
    console.log("urlCorServicei", urlCorServicei);
    let res = getDataindb(urlCorServicei)
    if (res) {
        if (document.getElementById(id)) { document.getElementById(id).innerHTML = Old_HTML; }
    }
    return res
}

export const OnGetJson = (url) => {
    /* console.log("OnGetJson"); */
    onLoading.onLoading("Y");
    var urlOnGetJson = getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken();
    console.log(urlOnGetJson);
    let res = getDataindb(urlOnGetJson)
    if (res) {
        onLoading.onLoading("N");
    }
    return res;
}

export const OnGetJsoni = (url, id) => {
    document.getElementById(id).innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
    var urlOnGetJsoni = getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken();
    console.log(urlOnGetJsoni);
    console.log(url, id);
    let res = getDataindb(urlOnGetJsoni)
    if (res) {
        document.getElementById(id).innerHTML = "";
    }
    return res;
}
export default class Loadding extends Component {
    render() {
        return (
            <div></div>
        )
    }
}
//--------------------------------------------------------------------------------
export async function getDataindb(urlapi) {
    try {
        let result = await axios.get(urlapi)
        return result
    } catch (error) {
        return "error"
    }
}

async function postDatatodb(urlapi, parameter) {
    try {
        let result = await axios.post(urlapi, parameter)
        return result
    } catch (error) {
        return "error"
    }
}
//----------------------------------------------------------------------------------
const hostname = window.location.hostname
// Example
// var url = "CSMAXDOC/MAXDOC?tablename=CSSTKISSUE&code=" + CODE;
// console.log(genURL(url));
// await axios.get(genURL(url), { timeout: 3600 }).then(res => {}
export const genURL = (url) => {
    return getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken()
}
// Example
// var url = "CSMAXDOC/MAXDOC?tablename=CSSTKISSUE&code=" + CODE;
// console.log(genURL(url));
// await axios.get(genURL(url), { timeout: 3600 }).then(res => {}
export const gengetURLTEST = (url) => {
    let url1 = url.split("/")
    // return "http://Localhost:8080/" + url1[1] + "&jwt=" + getToken();
    return "http://" + hostname + ":8080/" + url1[1] + "&jwt=" + getToken();
}
// Example
// let url = "CSSTKISSUE/Save?";
// await  axios.post(genpostURL(url), parameter).then(res => {}
export const genpostURL = (url) => {
    return getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken()
}
// Example
// let url = "CSSTKISSUE/Save?";
// await  axios.post(genpostURL(url), parameter).then(res => {}
export const genpostURLTEST = (url) => {
    // let urlnew = url.split("/")
    // return "http://Localhost:8080/" + urlnew[1] + "&jwt=" + getToken();
    return "http://" + hostname + ":8080" + url + "&jwt=" + getToken();
}

export const genURLTEST = (url) => {
    // let urlnew = url.split("/")
    // return "http://Localhost:8080/" + urlnew[1] + "&jwt=" + getToken(); 
    return `http://${hostname}:8080/${url}&jwt=` + getToken();

}

// ==================== Report API helpers (ported from v2.3.7) ====================
const DEFAULT_TIMEOUT = 15000; // 15 วินาที — ป้องกัน spinner ค้างเมื่อ backend ไม่ตอบ

// ถ้า backend ปฏิเสธ Bearer header ไปแล้วครั้งหนึ่ง ให้ใช้ legacy jwt query ตรงๆ ไม่ต้องลองซ้ำทุก request
let bearerRejected = false;

const createAuthConfig = () => {
    const token = getToken();
    const headers = { 'Content-Type': 'application/json' };
    if (token && token !== 'null' && token !== 'undefined') {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return { timeout: DEFAULT_TIMEOUT, headers };
};

async function getDataWithAuth(urlapi) {
    try {
        return await axios.get(urlapi, createAuthConfig());
    } catch (error) {
        if (error.response && error.response.status === 401) {
            bearerRejected = true;
        }
        return "error";
    }
}

// URL สำหรับส่ง JWT ผ่าน Authorization Header (ไม่ใส่ jwt ใน query string)
export const genPostURLWithAuth = (url) => getHostAPI() + url + "&api_key=" + getAPIKey();

export const GetCorServiceWithFallback = async (url) => {
    onLoading.onLoading("Y");
    try {
        if (!bearerRejected) {
            const res = await getDataWithAuth(genPostURLWithAuth(url));
            if (res !== "error") return res;
        }
        // Fallback: Bearer ล้มเหลว (CORS / network / 401) → ใช้ legacy jwt query
        return await getDataindb(genURL(url));
    } finally {
        onLoading.onLoading("N");
    }
}
